export const HANDLE_MODAL = 'neo-trading/dashboard/HANDLE_MODAL';
export const HIDE_DIALOG = 'neo-trading/app/HIDE_DIALOG';
export const ADD_SAMPLE_WIDGET = 'neo-trading/dashboard/ADD_SAMPLE_WIDGET';
export const WIDGET_THEMING_SUCCESS = 'neo-trading/dashboard/WIDGET_THEMING_SUCCESS';
export const WIDGET_THEMING_FAILURE = 'neo-trading/dashboard/WIDGET_THEMING_FAILURE';
export const GET_WIDGET_THEMING = 'neo-trading/dashboard/GET_WIDGET_THEMING';
export const GET_WIDGET_THEMING_SUCCESS = 'neo-trading/dashboard/GET_WIDGET_THEMING_SUCCESS';
export const GET_WIDGET_THEMING_FAILURE = 'neo-trading/dashboard/GET_WIDGET_THEMING_FAILURE';
export const NAVIGATE_TRADE_REPORT = 'neo-trading/tradepanel/NAVIGATE_TRADE_REPORT';
export const POPUP_WINDOW_HANDLE = 'neo-trading/tradepanel/POPUP_WINDOW_HANDLE';
export const POPUPCLOSE_HANDLE = 'neo-trading/tradepanel/POPUPCLOSE_HANDLE';
export const FORCED_LOGOUT = 'neo-trading/tradepanel/FORCED_LOGOUT';
export const ACC_MT_CHANGE_LOGOUT = 'neo-trading/tradepanel/ACC_MT_CHANGE_LOGOUT';
export const CL_FORCED_LOGOUT='neo-trading/tradepanel/CL_FORCED_LOGOUT';
export const KILL_SESSION='neo-trading/tradepanel/KILL_SESSION';
export const NOCHANGE='neo-trading/tradepanel/NOCHANGE';
export const LOAD_LOCK_FLAG='neo-trading/dashboard/LOAD_LOCK_FLAG';
export const LOCK_UNLOCK_FLAG='neo-trading/dashboard/LOCK_UNLOCK_FLAG';
export const UNLOCK_PSD_SUCCESS='neo-trading/dashboard/UNLOCK_PSD_SUCCESS';
export const CLEAR_KILL_SESSION='neo-trading/dashboard/CLEAR_KILL_SESSION';
export const LOAD_LANG='neo-trading/dashboard/LOAD_LANG';
export const UNLOCK_VERIFY = 'neo-trading/dashboard/UNLOCK_VERIFY';
export const UNLOCK_VERIFY_SUCCESS = 'neo-trading/dashboard/UNLOCK_VERIFY_SUCCESS';
export const UNLOCK_VERIFY_FAILURE = 'neo-trading/dashboard/UNLOCK_VERIFY_FAILURE';
export const RESET_UNLOCK = 'neo-trading/dashboard/RESET_UNLOCK';
export const GET_ALL_COLORS='neo-trading/dashboard/GET_ALL_COLORS';
export const GET_ALL_COLORS_SUCCESS='neo-trading/dashboard/GET_ALL_COLORS_SUCCESS';
export const GET_ALL_COLORS_FAILURE='neo-trading/dashboard/GET_ALL_COLORS_FAILURE';
export const CHANGE_THEME='neo-trading/dashboard/CHANGE_THEME';
export const SELECTED_CSS_THEME='neo-trading/dashboard/SELECTED_CSS_THEME';
export const IS_PROFILE_CLIKED='neo-trading/dashboard/IS_PROFILE_CLIKED';
export const UNLOCK_MODAL_STATUS = 'neo-trading/dashboard/UNLOCK_MODAL_STATUS';
export const UNLOCK_CHANGE_STATUS = 'neo-trading/dashboard/UNLOCK_CHANGE_STATUS';
export const CHANGE_CALENDAR_FLAG = 'neo-trading/dashboard/CHANGE_CALENDAR_FLAG';
export const RESET_THRESHOLDSTATE = 'neo-trading/dashboard/RESET_THRESHOLDSTATE';
export const GET_API_PATH = 'neo-trading/dashboard/GET_API_PATH';
export const SELECTED_LANG='neo-trading/dashboard/SELECTED_LANG';
export const LOAD_STKWISEPAIR = 'neo-trading/dashboard/LOAD_STKWISEPAIR';
export const LOAD_STKWISEPAIR_SUCCESS = 'neo-trading/dashboard/LOAD_STKWISEPAIR_SUCCESS';
export const LOAD_STKWISEPAIR_FAILURE = 'neo-trading/dashboard/LOAD_STKWISEPAIR_FAILURE';
export const VALIDATE_ORD_API = 'neo-trading/dashboard/VALIDATE_ORD_API';
export const SHOW_DIALOG = '';
export const VALIDATE_ORD_API_SUCCESS = 'neo-trading/dashboard/VALIDATE_ORD_API_SUCCESS';
export const VALIDATE_ORD_API_FAILURE = 'neo-trading/dashboard/VALIDATE_ORD_API_FAILURE';
export const LOADING_ON = 'neo-trading/auth/LOADING_ON';
export const LOADING_OFF = 'neo-trading/auth/LOADING_OFF';
export const HIDE_MODAL = 'neo-trading/tradepanel/HIDE_MODAL';
//Event Handler Error Log
export const LOG_FILE_CREATE ='LOG_FILE_CREATE';
export const SEND_LOG = 'SEND_LOG';
export const SEND_LOG_SUCCESS = 'SEND_LOG_SUCCESS';
export const SEND_LOG_FAILURE = 'SEND_LOG_FAILURE';

//Physical Delivery
export const LOAD_DELIVERIES = 'neo-trading/delivery/LOAD_DELIVERIES';
export const LOAD_DELIVERIES_SUCCESS = 'neo-trading/delivery/LOAD_DELIVERIES_SUCCESS';
export const LOAD_DELIVERIES_FAILURE = 'neo-trading/delivery/LOAD_DELIVERIES_FAILURE';

export const GET_MARGIN_FOR_PD = 'neo-trading/delivery/GET_MARGIN_FOR_PD';
export const GET_MARGIN_FOR_PD_SUCCESS = 'neo-trading/delivery/GET_MARGIN_FOR_PD_SUCCESS';
export const GET_MARGIN_FOR_PD_FAILURE = 'neo-trading/delivery/GET_MARGIN_FOR_PD_FAILURE';

export const GET_PREMIUM_DETAILS = 'neo-trading/delivery/GET_PREMIUM_DETAILS';
export const GET_PREMIUM_DETAILS_SUCCESS = 'neo-trading/delivery/GET_PREMIUM_DETAILS_SUCCESS';
export const GET_PREMIUM_DETAILS_FAILURE = 'neo-trading/delivery/GET_PREMIUM_DETAILS_FAILURE';

export const GET_LOCATION_DETAILS = 'neo-trading/delivery/GET_LOCATION_DETAILS';
export const GET_LOCATION_DETAILS_SUCCESS = 'neo-trading/delivery/GET_LOCATION_DETAILS_SUCCESS';
export const GET_LOCATION_DETAILS_FAILURE = 'neo-trading/delivery/GET_LOCATION_DETAILS_FAILURE';

export const PLACE_REQUEST = 'neo-trading/delivery/PLACE_REQUEST';
export const PLACE_REQUEST_SUCCESS = 'neo-trading/delivery/PLACE_REQUEST_SUCCESS';
export const PLACE_REQUEST_FAILURE = 'neo-trading/delivery/PLACE_REQUEST_FAILURE';

export const CANCEL_DELIVERY_REQUEST = 'neo-trading/delivery/CANCEL_DELIVERY_REQUEST';
export const CANCEL_DELIVERY_REQUEST_SUCCESS = 'neo-trading/delivery/CANCEL_DELIVERY_REQUEST_SUCCESS';
export const CANCEL_DELIVERY_REQUEST_FAILURE = 'neo-trading/delivery/CANCEL_DELIVERY_REQUEST_FAILURE';

export const UPDATE_PHYSICAL_DELIVERY_DATA = 'neo-trading/dashboard/UPDATE_PHYSICAL_DELIVERY_DATA';
export const UPDATE_OPEN_POSITIONS = 'neo-trading/dashboard/UPDATE_OPEN_POSITIONS';

export const HIDE_PLACE_REQUEST_SUCCESS_MODAL = 'neo-trading/dashboard/HIDE_PLACE_REQUEST_SUCCESS_MODAL';